import * as Yup from 'yup';
import i18n from 'i18n-js';

const fieldsByBroker = {
  GTBAD: ['name', 'device_id'],
  INVAD: ['name', 'external_type', 'device_id'],
};

const useBuildSchemaByBroker = (broker) => {
  const schema = {
    external_type: Yup.string().required(i18n.t('common.required_field')),
    device_id: Yup.string()
      .required(i18n.t('common.required_field'))
      .max(100, i18n.t('nfc.invalid_serial_length')),
  };

  const fields = fieldsByBroker[broker];
  var newSchema = {};
  if (fields) {
    newSchema = fields.reduce((auxSchema, field) => {
      const fieldInSchema = schema[field];
      if (fieldInSchema) {
        auxSchema[field] = fieldInSchema;
      }
      return auxSchema;
    }, {});
  }

  return newSchema;
};

const isRenderField = (broker, fieldName) => {
  const brokerFields = fieldsByBroker[broker];
  if (brokerFields) {
    return brokerFields.includes(fieldName);
  }
  return false;
};

export { useBuildSchemaByBroker, isRenderField };
